import React from "react";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import ContextMenu from "../../../components/contextMenu";
import {Calendar} from "primereact/calendar";
import {CALENDAR_ES, DATE_FORMAT_CALENDAR} from "../../../utils/constants/Constants";
import {dateFormatterReportTable} from "../../../utils/formatters/Date";
import {Column} from "primereact/column";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const ActiveMarketLoansView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle="Reportes \ Préstamos Vigentes de Mercado"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.getDataReport}
                                             disabledSearchButton = {props.disabledSearchButton}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-5 p-col-5">
                                    <SubtitleLabel header="Fecha Inicial" isBold={true}/>
                                    <Calendar name="startDate"
                                              locale={CALENDAR_ES}
                                              dateFormat={DATE_FORMAT_CALENDAR}
                                              disabledDays={[0, 6]}
                                              readOnlyInput={true}
                                              value={props.filters.startDate}
                                              onChange={props.onChangeFilters}
                                              maxDate={props.filters.today}
                                              monthNavigator={true}
                                              yearNavigator={true}
                                              yearRange={CALENDAR_ES['yearRange']}
                                              showButtonBar={true}
                                    />
                                </div>
                                <div className="p-col-12 p-md-5 p-col-5">
                                    <SubtitleLabel header="Fecha Final" isBold={true}/>
                                    <Calendar name="finalDate"
                                              locale={CALENDAR_ES}
                                              dateFormat={DATE_FORMAT_CALENDAR}
                                              disabledDays={[0, 6]}
                                              readOnlyInput={true}
                                              value={props.filters.finalDate}
                                              onChange={props.onChangeFilters}
                                              minDate={props.filters.startDate}
                                              maxDate={props.filters.today}
                                              monthNavigator={true}
                                              yearNavigator={true}
                                              yearRange={CALENDAR_ES['yearRange']}
                                              showButtonBar={true}
                                    />
                                </div>
                                <div className="p-col-12 p-md-2 p-col-2">
                                    <br/>
                                    <Button label="Limpiar"
                                            style={{'float': 'right'}}
                                            onClick={props.clearFilters}
                                            className="p-button-secondary"/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>

                    <Grid item xs={12} style={{textAlign: 'right'}}>
                        <ContextMenu menuOptions={props.exportOptions}
                                     isButton={true}
                                     label="Exportar"/>
                    </Grid>

                    <Grid item xs={12}>
                        <DataTable
                            value={props.dataReport}
                            scrollable={true}
                            style={{width: '100%'}}
                            resizableColumns={true}
                            columnResizeMode={"fit"}
                            scrollHeight="600px">
                            <Column field="fecha" header="Fecha" style={{textAlign: 'left', width: '100px'}}
                                    body={dateFormatterReportTable} sortable={true}/>
                            <Column field="emisora" header="Emisora" style={{textAlign: 'left', width: '100px'}}
                                    sortable={true}/>
                            <Column field="serie" header="Serie" style={{textAlign: 'left', width: '100px'}}
                                    sortable={true}/>
                            <Column field="tipoValor" header="Tipo Valor" style={{textAlign: 'left', width: '100px'}}
                                    sortable={true}/>
                            <Column field="cantidad" header="Títulos" style={{textAlign: 'right', width: '100px'}}
                                    sortable={true}/>
                            <Column field="tasa" header="Tasa" style={{textAlign: 'right', width: '100px'}}
                                    sortable={true}/>
                            <Column field="sobretasa" header="Sobretasa" style={{textAlign: 'right', width: '100px'}}
                                    sortable={true}/>
                            <Column field="plazo" header="Plazo" style={{textAlign: 'right', width: '100px'}}
                                    sortable={true}/>
                            <Column field="precio" header="Precio" style={{textAlign: 'right', width: '100px'}}
                                    sortable={true}/>
                            <Column field="importe" header="Importe" style={{textAlign: 'right', width: '100px'}}
                                    sortable={true}/>
                        </DataTable>
                    </Grid>
                    {props.confMsg}
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default ActiveMarketLoansView;